import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="11" height="14" viewBox="0 0 11 14" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M0 1.508a1.5 1.5 0 113 0v10.83a1.5 1.5 0 11-3 0V1.508zm7.692 0a1.5 1.5 0 113 0v10.83a1.5 1.5 0 11-3 0V1.508z" fill="#000" fillRule="evenodd" /></svg>;